import * as Inquiry from '../constants/inquiry.constant'
import * as App from '../constants/app.constant'
import * as inquiryService from '../services/inquiry.service'
import history from '../components/utils/history'
import { fromPromise } from 'rxjs/observable/fromPromise'
import { from } from 'rxjs/observable/from'
import { switchMap, map, catchError, finalize, tap } from 'rxjs/operators'
import { ofType, Epic } from 'redux-observable'
import { loading } from './app.epic'

const getInquiries: Epic<any> = action$ => {
  return action$.pipe(
    ofType(Inquiry.GET_INQUIRY_LOGS),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(Promise.resolve()).pipe(
        map(result => ({
          type: Inquiry.GET_INQUIRY_LOGS_SUCCESS,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Inquiry.GET_INQUIRY_LOGS_FAILURE, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        )
      )
    )
  )
}

const getInquiryDetails: Epic<any> = action$ => {
  return action$.pipe(
    ofType(Inquiry.GET_INQUIRY_LOG_DETAILS),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(Promise.resolve()).pipe(
        map(result => ({
          type: Inquiry.GET_INQUIRY_LOG_DETAILS_SUCCESS,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Inquiry.GET_INQUIRY_LOG_DETAILS_FAILURE, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        )
      )
    )
  )
}

const postInquiryQuestion: Epic<any> = action$ => {
  return action$.pipe(
    ofType(Inquiry.POST_INQUIRY_QUESTION),
    tap(() => loading.show()),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(inquiryService.postInquiryService(payload)).pipe(
        map(result => ({
          type: Inquiry.DONE_POST_INQUIRY_QUESTION,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Inquiry.FAILURE_POST_INQUIRY_QUESTION, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        ),
        finalize(() => {
          loading.hide()
          history.push('/inquiry')
        })
      )
    )
  )
}

const putInquiry: Epic<any> = action$ => {
  return action$.pipe(
    ofType(Inquiry.PUT_INQUIRY),
    tap(() => loading.show()),
    map((action: any) => action.payload),
    switchMap((payload: any) =>
      fromPromise(inquiryService.putInquiryService(payload)).pipe(
        map(result => ({
          type: Inquiry.DONE_PUT_INQUIRY,
          payload: result,
        })),
        catchError(error =>
          from([
            { type: Inquiry.FAILURE_PUT_INQUIRY, payload },
            { type: App.SHOW_ERROR, payload: error.message },
          ])
        ),
        finalize(() => loading.hide())
      )
    )
  )
}

export default [
  getInquiries,
  getInquiryDetails,
  postInquiryQuestion,
  putInquiry,
]



// WEBPACK FOOTER //
// ./src/epics/inquiry.epic.ts